export const getPrintTemplate = ({ headerInfo, rows }) => {
  const fmt = (n) => (n && n !== 0 && !isNaN(n) ? new Intl.NumberFormat("vi-VN").format(n) : "");

  let totalIncreaseQuantity = 0;
  let totalIncreaseParValue = 0;
  let totalIncreaseActual = 0;
  let totalDecreaseQuantity = 0;
  let totalDecreaseParValue = 0;
  let totalDecreaseActual = 0;

  const renderRows = rows
    .map((row) => {
      const incQ = parseFloat(row.increaseQuantity) || 0;
      const incP = parseFloat(row.increaseParValue) || 0;
      const incA = parseFloat(row.increaseActualPurchasePrice) || 0;
      const decQ = parseFloat(row.decreaseQuantity) || 0;
      const decP = parseFloat(row.decreaseParValue) || 0;
      const decA = parseFloat(row.decreaseActualPurchasePrice) || 0;

      totalIncreaseQuantity += incQ;
      totalIncreaseParValue += incP;
      totalIncreaseActual += incA;
      totalDecreaseQuantity += decQ;
      totalDecreaseParValue += decP;
      totalDecreaseActual += decA;

      return `
      <tr>
        <td class="td-center">${row.recordingDate || ""}</td>
        <td class="td-center">${row.voucherNumber || ""}</td>
        <td class="td-center">${row.voucherDate || ""}</td>
        <td class="td-left">${row.description || ""}</td>
        <td class="td-center">${row.correspondingAccount || ""}</td>
        <td class="td-right">${fmt(row.actualPrice)}</td>
        <td class="td-right">${fmt(row.increaseQuantity)}</td>
        <td class="td-right">${fmt(row.increaseParValue)}</td>
        <td class="td-right">${fmt(row.increaseActualPurchasePrice)}</td>
        <td class="td-right">${fmt(row.decreaseQuantity)}</td>
        <td class="td-right">${fmt(row.decreaseParValue)}</td>
        <td class="td-right">${fmt(row.decreaseActualPurchasePrice)}</td>
        <td class="td-right">${fmt(row.balanceQuantity)}</td>
        <td class="td-right">${fmt(row.balanceParValue)}</td>
        <td class="td-right">${fmt(row.balanceActualPurchasePrice)}</td>
      </tr>
    `;
    })
    .join("");

  return `
    <html>
      <head>
        <title>Sổ Chi Tiết Cổ Phiếu Mua Lại (S44-DN)</title>
        <style>
          body {
            font-family: "Times New Roman", Times, serif;
            font-size: 14px;
            color: #000;
            padding: 20px;
            margin: 0;
          }
          .header-top {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
          }
          .bold { font-weight: bold; }
          .italic { font-style: italic; }
          .text-center { textAlign: center; }
          .title-main { font-size: 18px; font-weight: bold; text-align: center; text-transform: uppercase; margin: 0; }
          .title-box { text-align: center; margin: 20px 0; }
          table { width: 100%; border-collapse: collapse; margin-top: 15px; font-size: 14px; }
          th, td { border: 1px solid #000; padding: 4px; vertical-align: middle; }
          th { font-weight: bold; text-align: center; }
          .td-center { text-align: center; }
          .td-right { text-align: right; }
          .td-left { text-align: left; }
          .footer-sign { display: flex; justify-content: space-between; margin-top: 30px; text-align: center; }
          .sign-col { width: 33%; }
        </style>
      </head>
      <body>
        <div class="header-top">
          <div style="width: 45%;">
            <div class="bold">Đơn vị: ${headerInfo.unit || ".............................."}</div>
            <div class="bold">Địa chỉ: ${headerInfo.companyAddress || ".............................."}</div>
          </div>
          <div style="text-align: center; width: 55%;">
            <div class="bold">Mẫu số S44-DN</div>
            <div class="italic" style="margin-top: 4px;">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </div>
        </div>
        
        <div class="title-box">
          <h2 class="title-main">SỔ CHI TIẾT CỔ PHIẾU MUA LẠI CỦA CHÍNH MÌNH</h2>
          <div class="bold" style="margin-top: 5px;">Năm: ${headerInfo.year || "..............."}</div>
          <div style="margin-top: 5px; display: flex; justify-content: center; gap: 20px;">
            <div class="bold">Loại cổ phiếu: ${headerInfo.shareType || "............."}</div>
            <div class="bold">Mã số: ${headerInfo.shareCode || "............."}</div>
          </div>
          <div style="text-align: right; margin-top: 5px;" class="italic">
            Đơn vị tính: ${headerInfo.measurementUnit || ".............."}
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th rowspan="3" style="width: 6%">Ngày<br/>tháng<br/>ghi sổ</th>
              <th colspan="2" style="width: 10%">Chứng từ</th>
              <th rowspan="3" style="width: 15%">Diễn giải</th>
              <th rowspan="3" style="width: 5%">Tài<br/>khoản<br/>đối ứng</th>
              <th rowspan="3" style="width: 6%">Giá<br/>thực<br/>tế<br/>mua,<br/>tái<br/>phát<br/>hành</th>
              <th colspan="6" style="width: 36%">Số phát sinh</th>
              <th colspan="3" style="width: 18%">Số dư</th>
            </tr>
            <tr>
              <th rowspan="2">Số<br/>hiệu</th>
              <th rowspan="2">Ngày<br/>tháng</th>
              <th colspan="3">Tăng</th>
              <th colspan="3">Giảm</th>
              <th rowspan="2">Số<br/>lượng</th>
              <th rowspan="2">Giá trị<br/>theo<br/>mệnh<br/>giá</th>
              <th rowspan="2">Giá<br/>mua<br/>thực<br/>tế</th>
            </tr>
            <tr>
              <th>Số<br/>lượng</th>
              <th>Giá trị<br/>theo<br/>mệnh<br/>giá</th>
              <th>Giá<br/>mua<br/>thực<br/>tế</th>
              <th>Số<br/>lượng</th>
              <th>Giá trị<br/>theo<br/>mệnh<br/>giá</th>
              <th>Giá<br/>mua<br/>thực<br/>tế</th>
            </tr>
            <tr style="background-color: #f0f0f0;">
              <th>A</th>
              <th>B</th>
              <th>C</th>
              <th>D</th>
              <th>E</th>
              <th>1</th>
              <th>2</th>
              <th>3</th>
              <th>4</th>
              <th>5</th>
              <th>6</th>
              <th>7</th>
              <th>8</th>
              <th>9</th>
              <th>10</th>
            </tr>
          </thead>
          <tbody>
            ${renderRows}
            <tr style="background-color: #fafafa; font-weight: bold;">
              <td colspan="4" class="td-center">Cộng</td>
              <td class="td-center">x</td>
              <td class="td-center">x</td>
              <td class="td-right">${fmt(totalIncreaseQuantity)}</td>
              <td class="td-right">${fmt(totalIncreaseParValue)}</td>
              <td class="td-right">${fmt(totalIncreaseActual)}</td>
              <td class="td-right">${fmt(totalDecreaseQuantity)}</td>
              <td class="td-right">${fmt(totalDecreaseParValue)}</td>
              <td class="td-right">${fmt(totalDecreaseActual)}</td>
              <td class="td-center">x</td>
              <td class="td-center">x</td>
              <td class="td-center">x</td>
            </tr>
          </tbody>
        </table>

        <div style="margin-top: 20px;">
          <div>- Sổ này có: <span class="bold">${headerInfo.totalPages || "....."}</span> trang, đánh số từ trang 01 đến trang...</div>
          <div>- Ngày mở sổ: <span class="bold">${headerInfo.openingDate || ".................."}</span></div>
        </div>

        <div class="footer-sign">
          <div class="sign-col">
            <div class="bold">Người ghi sổ</div>
            <div class="italic" style="margin-bottom: 60px;">(Ký, họ tên)</div>
            <div class="bold">${headerInfo.recorder || "........................"}</div>
          </div>
          <div class="sign-col">
            <div class="bold">Kế toán trưởng</div>
            <div class="italic" style="margin-bottom: 60px;">(Ký, họ tên)</div>
            <div class="bold">${headerInfo.chiefAccountant || "........................"}</div>
          </div>
          <div class="sign-col">
            <div class="italic" style="margin-bottom: 5px;">
              Ngày ${headerInfo.signingDay || "..."} tháng ${headerInfo.signingMonth || "..."} năm ${headerInfo.signingYear || "..."}
            </div>
            <div class="bold">Người đại diện theo pháp luật</div>
            <div class="italic" style="margin-bottom: 40px;">(Ký, họ tên, đóng dấu)</div>
            <div class="bold">${headerInfo.legalRepresentative || "........................"}</div>
          </div>
        </div>
      </body>
    </html>
  `;
};
